exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".main___3zPRG{\n    padding: 20px 18px 10px 18px;\n}\n\n\n.title___1-cmW{\n    font-size: 19px;\n    font-weight: 500;\n    color: #222222;\n    line-height: 20px;    \n}\n\n\n\n\n.bottom___2ZZAH{\n    padding-left: 18px;\n    padding-right: 18px;\n  \n}\n\n.img___1rZYF{\n    width: 100px;\n    float: left;\n    /* shape-outside: circle(); */\n    margin: 0 10px 0px 0px;\n}\n\n.content___nK5Hr{\n    margin-top: 30px;\n}\n\n.contentP___3gdCH{\n    font-size: 15px;\n    color: #222222;\n    line-height: 27px; \n    text-align:unset;\n    letter-spacing: 2px;\n}", ""]);

// exports
exports.locals = {
	"main": "main___3zPRG",
	"title": "title___1-cmW",
	"bottom": "bottom___2ZZAH",
	"img": "img___1rZYF",
	"content": "content___nK5Hr",
	"contentP": "contentP___3gdCH"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/css/Artisan.css
// module id = 781
// module chunks = 2